import React from 'react'
import TableCellDesktop from './TableCellDesktop'

const TableCellSolde = ({ item }) => {
  return (
    <TableCellDesktop
      center={true}
      value={item.solde}
    />
  )
}

export default TableCellSolde
